import "@babel/polyfill";
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue';
import MobileHeader from './vue/mobile-header.vue';
import Header from './vue/header.vue';
import Autocomplete from '@trevoreyre/autocomplete-vue';
import store from './vue/store';
import 'lazysizes';
import vueDebounce from 'vue-debounce'
import 'focus-visible';
import { VueMasonryPlugin } from 'vue-masonry';
import './templateImages';
import './general';

import 'jquery';
import 'bootstrap/js/src/modal';
import './form';

require("fslightbox");

Vue.use(Autocomplete);
Vue.use(vueDebounce);
Vue.use(VueMasonryPlugin);

let nodes = document.querySelectorAll('.js-vue');

for (let node of nodes) {

    if (node.getElementsByTagName("mobile-header").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'mobile-header': MobileHeader
            }
        });
    }

    if (node.getElementsByTagName("desktop-header").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'desktop-header': Header
            }
        });
    }


    if(node.getElementsByTagName("campaign-header").length) {
			new Vue({
				el: node,
				store: store,
				components: {
					'campaign-header': () => import(/* webpackChunkName: "campaign-header" */ './vue/campaign/campaign-header.vue')
				}
			});
    }


    if (node.getElementsByTagName("water-history-header").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'water-history-header': () => import(/* webpackChunkName: "water-history-header" */ './vue/WaterHistory/water-history-header.vue')
            }
        });
    }


    if (node.getElementsByTagName("water-history-mobile-header").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'water-history-mobile-header': () => import(/* webpackChunkName: "water-history-mobile-header" */ './vue/WaterHistory/water-history-mobile-header.vue')
            }
        });
    }

    if(node.getElementsByTagName("infocard-list").length) {
			new Vue({
				el: node,
				store: store,
				components: {
					'infocard-list': () => import(/* webpackChunkName: "infocard-list" */ './vue/infocard-list.vue')
				}
			});
    }

    if(node.getElementsByTagName("campaign-mobile-header").length) {
			new Vue({
				el: node,
				store: store,
				components: {
					'campaign-mobile-header': () => import(/* webpackChunkName: "campaign-mobile-header" */ './vue/campaign/campaign-mobile-header.vue')
				}
			});
    }

    if (node.getElementsByTagName("gift-list-search-results").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'gift-list-search-results': () => import(/* webpackChunkName: "gift-list-search-results" */ './vue/campaign/gift-list-search-results.vue')
            }
        });
    }

    if (node.getElementsByTagName("single-gift-item").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'single-gift-item': () => import(/* webpackChunkName: "single-gift-item" */ './vue/campaign/single-gift-item.vue')
            }
        });
    }

		if(node.getElementsByTagName("waste-search").length) {
			new Vue({
				el: node,
				store: store,
				components: {
					'waste-search': () => import(/* webpackChunkName: "waste-search" */ './vue/waste-search.vue')
				}
			});
    }
    
    if(node.getElementsByTagName("video-list").length) {
			new Vue({
				el: node,
				store: store,
				components: {
					'video-list': () => import(/* webpackChunkName: "video-list" */ './vue/video-list.vue')
				}
			});
		}
    if(node.getElementsByTagName("vertical-video-list").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'vertical-video-list': () => import(/* webpackChunkName: "vertical-video-list" */ './vue/vertical-video-list.vue')
            }
        });
    }

		if(node.getElementsByTagName("related-lift").length) {
			new Vue({
				el: node,
				store: store,
				components: {
					'related-lift': () => import(/* webpackChunkName: "related-lift" */ './vue/related-lift.vue')
				}
			});
		}

    if (node.getElementsByTagName("event-lift").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'event-lift': () => import(/* webpackChunkName: "event-lift" */ './vue/event-lift.vue')
            }
        });
    }

    if (node.getElementsByTagName("listing").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'listing': () => import(/* webpackChunkName: "listing" */ './vue/Listing/listing.vue')
            }
        });
    }

    if (node.getElementsByTagName("related-pages").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'related-pages': () => import(/* webpackChunkName: "related-pages" */ './vue/related-pages.vue')
            }
        });
    }

    if (node.getElementsByTagName("accordion").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'accordion': () => import(/* webpackChunkName: "accordion" */ './vue/accordion.vue')
            }
        });
    }

    if (node.getElementsByTagName("crisis-block").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'crisis-block': () => import(/* webpackChunkName: "crisis-block" */ './vue/crisis-block.vue')
            }
        });
    }

    if (node.getElementsByTagName("waste-search-result").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'waste-search-result': () => import(/* webpackChunkName: "waste-search-result" */ './vue/waste-search-result.vue')
            }
        });
    }

    if (node.getElementsByTagName("water-supply-breaks-filter").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'water-supply-breaks-filter': () => import(/* webpackChunkName: "water-supply-breaks-filter" */ './vue/WaterSupply/water-supply-breaks-filter.vue')
            }
        });
    }

    if (node.getElementsByTagName("joining-payment-calculator").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'joining-payment-calculator': () => import(/* webpackChunkName: "joining-payment-calculator" */ './vue/calculators/joining-payment-calculator.vue')
            }
        });
    }

    if (node.getElementsByTagName("joining-payment-summary").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'joining-payment-summary': () => import(/* webpackChunkName: "joining-payment-summary" */ './vue/calculators/joining-payment-summary.vue')
            }
        });
    }

    if (node.getElementsByTagName("water-payment-calculator").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'water-payment-calculator': () => import(/* webpackChunkName: "water-payment-calculator" */ './vue/calculators/water-payment-calculator.vue')
            }
        });
    }

    if (node.getElementsByTagName("water-payment-summary").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'water-payment-summary': () => import(/* webpackChunkName: "water-payment-summary" */ './vue/calculators/water-payment-summary.vue')
            }
        });
    }

    if (node.getElementsByTagName("contact-block").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'contact-block': () => import(/* webpackChunkName: "contact-block" */ './vue/contact-block.vue')
            }
        });
    }

    if (node.getElementsByTagName("search").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'search': () => import(/* webpackChunkName: "search" */ './vue/search.vue'),
                'custom-input': () => import(/* webpackChunkName: "custom-input" */ './vue/custom-input.vue'),
            }
        });
    }

    if (node.getElementsByTagName("anchor-links-block").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'anchor-links-block': () => import(/* webpackChunkName: "anchor-links-block" */ './vue/anchor-links-block.vue')
            }
        });
    }

    if (node.getElementsByTagName("link-to-top").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'link-to-top': () => import(/* webpackChunkName: "link-to-top" */ './vue/link-to-top.vue')
            }
        });
    }

    if (node.getElementsByTagName("water-supply-report-lift").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'water-supply-report-lift': () => import(/* webpackChunkName: "water-supply-report-lift" */ './vue/WaterSupply/water-supply-report-lift.vue')
            }
        });
    }

    if (node.getElementsByTagName("climate-action-search").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'climate-action-search': () => import(/* webpackChunkName: "climate-action-search" */ './vue/ClimateAction/climate-action-search.vue')
            }
        });
    }

    if (node.getElementsByTagName("air-quality-report-lift").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'air-quality-report-lift': () => import(/* webpackChunkName: "air-quality-report-lift" */ './vue/air-quality-report-lift.vue')
            }
        });
    }

    if (node.getElementsByTagName("collection-vehicles-block").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'collection-vehicles-block': () => import(/* webpackChunkName: "collection-vehicles-block" */ './vue/collection-vehicles-block.vue')
            }
        });
    }

    if (node.getElementsByTagName("collection-vehicle-search").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'collection-vehicle-search': () => import(/* webpackChunkName: "collection-vehicle-search" */ './vue/collection-vehicles-search.vue')
            }
        });
    }

    if (node.getElementsByTagName("collection-vehicle-map-search").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'collection-vehicle-map-search': () => import(/* webpackChunkName: "collection-vehicle-map-search" */ './vue/collection-vehicles-map-search.vue')
            }
        });
    }

    if (node.getElementsByTagName("collection-vehicle-search-block").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'collection-vehicle-search-block': () => import(/* webpackChunkName: "collection-vehicle-search-block" */ './vue/collection-vehicle-search-block.vue')
            }
        });
    }

    if (node.getElementsByTagName("collection-vehicle-map-search-block").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'collection-vehicle-map-search-block': () => import(/* webpackChunkName: "collection-vehicle-map-search-block" */ './vue/collection-vehicle-map-search-block.vue')
            }
        });
    }

    if (node.getElementsByTagName("hero-search").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'hero-search': () => import(/* webpackChunkName: "hero-search" */ './vue/hero-search.vue')
            }
        });
    }

    if (node.getElementsByTagName("rss-feed").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'rss-feed': () => import(/* webpackChunkName: "rss-feed" */ './vue/rss-feed.vue')
            }
        });
    }

    if (node.getElementsByTagName("air-quality-graphs").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'air-quality-graphs': () => import(/* webpackChunkName: "air-quality-graphs" */ './vue/AirQualityGraphs/air-quality-graphs.vue')
            }
        });
    }

    if (node.getElementsByTagName("measuring-station-map").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'measuring-station-map': () => import(/* webpackChunkName: "measuring-station-map" */ './vue/MeasuringStationMap/measuring-station-map.vue')
            }
        });
    }

    if (node.getElementsByTagName("opendata-resources-accordion").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'opendata-resources-accordion': () => import(/* webpackChunkName: "opendata-resources-accordion" */ './vue/OpenData/opendata-resources-accordion.vue')
            }
        });
    }
    if (node.getElementsByTagName("open-data-search-hero").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'open-data-search-hero': () => import(/* webpackChunkName: "open-data-search-hero" */ './vue/OpenData/open-data-search-hero.vue')
            }
        });
    }
    if (node.getElementsByTagName("open-data-search").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'open-data-search': () => import(/* webpackChunkName: "open-data-search" */ './vue/OpenData/open-data-search.vue')
            }
        });
    }
    if (node.getElementsByTagName("open-data-search-results").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'open-data-search-results': () => import(/* webpackChunkName: "open-data-search-results" */ './vue/OpenData/open-data-search-results.vue')
            }
        });
    }
    if (node.getElementsByTagName("location-week-calendar").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'location-week-calendar': () => import(/* webpackChunkName: "location-week-calendar" */ './vue/location-week-calendar.vue')
            }
        });
    }
    if (node.getElementsByTagName("page-navigation-block").length) {
        new Vue({
            el: node,
            store: store,
            components: {
                'page-navigation-block': () => import(/* webpackChunkName: "page-navigation-block" */ './vue/page-navigation-block.vue')
            }
        });
    }
}
